import React, { Component } from 'react';

import "./FormFooter.scss"

class FormFooter extends Component {
  constructor(props) {
    super();
    this.state = {

    }
  }
  render() {
    return (
      <section className="section section-footer">
        <div className="formfooter">
          <div className="rightside">
            <input type="checkbox" name="AcceptedTakanon" id="AcceptedTakanon" value="1" onChange={this.props.handleInputChange} />
            <label htmlFor="AcceptedTakanon">
              <div className="taknon" dangerouslySetInnerHTML={{ __html: this.props.data.taknon }}></div>
            </label>
          </div>
          <div className="leftside">
            <div className="sendbutton" onClick={this.props.sendForm}>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FormFooter;



// WEBPACK FOOTER //
// ./src/Components/FormBody/FormFooter.js